'use strict';

import Observable from './Observable';
import Observer from './Observer';
import Logger from './Logger';

var notifiersOfWidgets = {};

var Events = (function () {
    var eventsTriggers = {
        timer : timer,
        idle_timer : idleTimer,
        mouse_out_top : mouseOutTop,
        mouse_out : mouseOut,
        add_to_cart: addToCartLH,
        local_storage_key: editLocalStorageKey,
        timer_from_the_beginning_of_the_visit: timerFromTheBeginningOfTheVisit

    };

    // API function, which add listeners to widget
    function bind(widgetId, eventType, eventValue, widgetShowMethod, validator) {
        // Get trigger from list base on incoming parameters
        var initTrigger = eventsTriggers[eventType];

        // If no notifiers for current widgetId - make new Observable instance
        if (!notifiersOfWidgets[widgetId]) {
            notifiersOfWidgets[widgetId] = new Observable(widgetId);
        }

        // Save notifier in variable
        var notifier = notifiersOfWidgets[widgetId];
        // Run trigger
        initTrigger(eventValue, widgetShowMethod, notifier, validator, widgetId);

        return notifier;
    }

    function timerFromTheBeginningOfTheVisit(eventValue, widgetShowMethod, notifier, validator, widgetId) {
        var seconds = parseInt(eventValue)
        seconds = (isNaN(seconds)) ? null : (seconds !== 0) ? seconds : 0
    
        var widgetVariables = window.lhWidgetSystem.getWidgetVariablesByWidgetId(widgetId)
        widgetVariables['timer_from_the_beginning_of_the_visit'] = 0
    
        // Получаем номер текущего визита из localStorage
        var currentVisitCount = localStorage.getItem('_lh_visits_count')
    
        // Устанавливаем начальное значение времени в localStorage, если оно еще не установлено или если визит новый
        if (!localStorage.getItem('timer_from_the_beginning_of_the_visit_start') ||
            localStorage.getItem('timer_from_the_beginning_of_the_visit_visit_count') !== currentVisitCount) {
            localStorage.setItem('timer_from_the_beginning_of_the_visit_start', Date.now());
            localStorage.setItem('timer_from_the_beginning_of_the_visit_visit_count', currentVisitCount)
        }
    
        // Функция для обновления таймера
        function updateTimer() {
            var startTimestamp = parseInt(localStorage.getItem('timer_from_the_beginning_of_the_visit_start'))
            var elapsedSeconds = Math.floor((Date.now() - startTimestamp) / 1000)
            widgetVariables['timer_from_the_beginning_of_the_visit'] = elapsedSeconds
    
            if ((seconds !== null) && elapsedSeconds >= seconds) {
                callShowMethod()
            }
        }
    
        // Обновляем таймер каждую секунду
        var timeout = setInterval(updateTimer, 1000)
    
        // Обработчик вызова метода отображения виджета
        function callShowMethod() {
            Logger.log('DONE TIMER FROM THE BEGINNING OF THE VISIT')
    
            if (validator.validate()) {
                widgetShowMethod()
                notifier.notifyObservers()
                widgetVariables['widget_shown'] = true
            }
    
            unbind()
        }
    
        // Функция очистки
        function unbind() {
            clearInterval(timeout)
            window.removeEventListener('storage', onStorageChange)
        }
    
        // Добавляем наблюдателя для удаления таймера при отключении
        notifier.addObserver(new Observer(unbind))
    
        // Функция для обработки изменений в localStorage
        function onStorageChange(event) {
            if (event.key === 'timer_from_the_beginning_of_the_visit_start' || event.key === '_lh_visits_count') {
                updateTimer()
            }
        }
    
        // Добавляем слушатель для события изменения localStorage
        window.addEventListener('storage', onStorageChange)
    
        // Инициализируем таймер сразу при запуске
        updateTimer()
    }
    

    function timer(secondsValue, widgetShowMethod, notifier, validator, widgetId) {
        var seconds = parseInt(secondsValue);
        seconds = (seconds !== seconds) ? null : (seconds !== 0) ? seconds : 0;

        var widgetVariables = window.lhWidgetSystem.getWidgetVariablesByWidgetId(widgetId);

        widgetVariables['timer'] = 0;

        var timeout = setInterval(function() {
            if ((seconds === null) || widgetVariables['timer'] < seconds) {
                widgetVariables['timer'] += 1;
            } else {
                callShowMethod();
            }
        }, 1000);

        function callShowMethod () {
            Logger.log('DONE SIMPLE TIMER');

            if (validator.validate()) {
                widgetShowMethod();
                notifier.notifyObservers();

                widgetVariables['widget_shown'] = true;
            }

            unbind();
        }

        function unbind() {
            clearInterval(timeout);
        }

        notifier.addObserver(new Observer(unbind));
    }

    function idleTimer(secondsValue, widgetShowMethod, notifier, validator, widgetId) {
        var seconds = parseInt(secondsValue);
        seconds = (seconds !== seconds) ? null : (seconds !== 0) ? seconds : 0;

        var timeout;
        var widgetVariables = window.lhWidgetSystem.getWidgetVariablesByWidgetId(widgetId);

        function resetTimer() {
            clearTimeout(timeout);
            widgetVariables['idle_timer'] = 0;

            timeout = setInterval(function() {
                if ((seconds === null) || widgetVariables['idle_timer'] < seconds) {
                    widgetVariables['idle_timer'] += 1;
                } else {
                    callShowMethod();
                }
            }, 1000);
        }

        document.addEventListener('mousemove', resetTimer);
        document.addEventListener('keypress', resetTimer);

        function callShowMethod() {
            Logger.log('DONE IDLE TIMER');
            if (validator.validate()) {
                widgetShowMethod();
                notifier.notifyObservers();

                widgetVariables['widget_shown'] = true;
            }

            unbind();
        }

        function unbind() {
            clearInterval(timeout);
            document.removeEventListener('mousemove', resetTimer);
            document.removeEventListener('onkeypress', resetTimer);
        }

        notifier.addObserver(new Observer(unbind));
    }

    function mouseOutTop(eventValue, widgetShowMethod, notifier, validator, widgetId) {
        if (eventValue !== 1) {
            return false;
        }

        var widgetVariables = window.lhWidgetSystem.getWidgetVariablesByWidgetId(widgetId);
        var xPosition = null;
        var yPosition = null;

        if ( parseInt(window.Leadhit.Util.cookie.get('lh_widget_system_pages_counter')) > 0 && Boolean(window.Leadhit.Util.cookie.get(window.Leadhit.LHWidget.context[widgetId]['js']['closed_cookie_name'])) )
        {
            widgetShowMethod();
            widgetVariables['widget_shown'] = true;
        } else {
            document.addEventListener('mouseout', isMouseOutTop);

            function isMouseOutTop(e) {
                var isOutOfPage = isMouseOutOfPage(e);
                // Get current mouse position coordinates
                var x = e.clientX;
                var y = e.clientY;
                // If previous positions is not set,
                // and mouse is not out of page - set current mouse position
                if (xPosition === null && yPosition === null || !isOutOfPage) {
                    xPosition = x;
                    yPosition = y;
                }
                // Is mouse out of window
                if (isOutOfPage) {
                    // Check:
                    // 1. If new mouse y position is less then previous
                    // 2. If new mouse y position is less then fix pixel size from top
                    // 3. If new mouse x position is more then 0
                    if (y < yPosition && y <= 50 && x >= 100) {
                        // Mouse gone out top of window
                        callShowMethod();
                    }
                }
            }

            function callShowMethod() {
                Logger.log('DONE MOUSE OUT TOP');
                if (validator.validate()) {
                    var result = widgetShowMethod();

                    if (result !== -1) {
                        notifier.notifyObservers();
                        widgetVariables['widget_shown'] = true;
                        unbind();
                    }
                }
            }

            function unbind() {
                document.removeEventListener('mouseout', isMouseOutTop);
            }

            notifier.addObserver(new Observer(unbind));
        }
    }

    function mouseOut(eventValue, widgetShowMethod, notifier, validator, widgetId) {
        if (eventValue !== 1) {
            return false;
        }

        var widgetVariables = window.lhWidgetSystem.getWidgetVariablesByWidgetId(widgetId);

        document.addEventListener('mouseout', isMouseOut);

        function isMouseOut(e) {
            if (isMouseOutOfPage(e)) {
                callShowMethod();
            }
        }

        function callShowMethod() {
            Logger.log('DONE MOUSE OUT OF PAGE');
            if (validator.validate()) {
                var result = widgetShowMethod();

                if (result !== -1) {
                    notifier.notifyObservers();
                    widgetVariables['widget_shown'] = true;
                    unbind();
                }
            }
        }

        function unbind() {
            document.removeEventListener('mouseout', isMouseOut);
        }

        notifier.addObserver(new Observer(unbind));
    }

    function addToCartLH(secondsValue, widgetShowMethod, notifier, validator, widgetId) {
        if (secondsValue !== 1) {
            return false;
        }

        var widgetVariables = window.lhWidgetSystem.getWidgetVariablesByWidgetId(widgetId);

        document.addEventListener('addToCartLH', callShowMethod)

        function callShowMethod () {
            Logger.log('DONE SIMPLE addToCartLH');

            if (validator.validate()) {
                widgetShowMethod();
                notifier.notifyObservers();

                widgetVariables['widget_shown'] = true;
            }

            unbind();
        }

        function unbind() {
            document.removeEventListener('addToCartLH', callShowMethod);
        }

        notifier.addObserver(new Observer(unbind));
    }

    function editLocalStorageKey(eventValue, widgetShowMethod, notifier, validator, widgetId) {
        if (!eventValue || eventValue.length === 0) {
            return false
        }

        var widgetVariables = window.lhWidgetSystem.getWidgetVariablesByWidgetId(widgetId)

        window.lhWidgetSystem.callShowMethod = function (event) {
            Logger.log('DONE SIMPLE LISTNER')
            if (validator.validate() && event.key === eventValue && 
            (!window.Leadhit.store.state.local_storage_value || window.Leadhit.store.state.local_storage_value != localStorage.getItem(eventValue))) {
                window.Leadhit.store.state.local_storage_key = eventValue
                window.Leadhit.store.state.local_storage_value = localStorage.getItem(eventValue)
                widgetShowMethod()
                widgetVariables['widget_shown'] = true
            }
        }

        if(localStorage.getItem(eventValue) && localStorage.getItem(eventValue).length > 0) {
            window.lhWidgetSystem.callShowMethod({key: eventValue})
        }

        let additional_frame = document.createElement('iframe')
        document.body.appendChild(additional_frame)
        additional_frame.style.visibility = 'hidden'
        additional_frame.style.position = 'absolute'
        additional_frame.style.width = 0
        additional_frame.style.height = 0
        additional_frame.style.border = 'unset'

        let frame_script = document.createElement('script')
        frame_script.innerHTML = 'window.addEventListener("storage", window.parent.lhWidgetSystem.callShowMethod);'
        additional_frame.contentWindow.document.body.appendChild(frame_script)

    }

    /*
    * Helpers
    * */
    function isMouseOutOfPage(e) {
        return typeof e.toElement === 'undefined' ? Boolean(e.relatedTarget === null) :
            Boolean(e.toElement === null && e.relatedTarget === null);

    }

    return {
        listen : bind
    };
})();

export default Events;